import { render, staticRenderFns } from "./Pop2.vue?vue&type=template&id=0f165264&scoped=true&"
import script from "./Pop2.vue?vue&type=script&lang=js&"
export * from "./Pop2.vue?vue&type=script&lang=js&"
import style0 from "./Pop2.vue?vue&type=style&index=0&id=0f165264&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f165264",
  null
  
)

export default component.exports